import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { IRunAutoTaskExecutorProps } from './IRunAutoTaskExecutorProps';
import { RunAutoTaskExecutorModal } from './RunAutoTaskExecutorModal';

export const RunAutoTaskExecutor = createDocModalExecutor<IRunAutoTaskExecutorProps>({
    modal: RunAutoTaskExecutorModal,
    defaultModalSize: 'l',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        message: action.options?.message ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        showSuccessText: action.options?.showSuccessText ?? false,
        successText: action.options?.successText,
        completeHandler,
    }),
});
